module.exports = new __parcel__URL__("calendar-app-skeleton.tpl.77b09222.svg").toString();